module.exports = __webpack_public_path__ + "static/media/qindex1.08755dda.png";